<template>
  <div class="adress-wrap">
    <van-form @submit="onSubmit">
      <van-field
        readonly
        clickable
        label="所在地"
        :value="newAddress"
        placeholder="地区信息"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <!-- <van-area
          :area-list="areaList"
          :columns-num="3"
          title="选择地址"
          @confirm="confirmAddress"
          @cancel="cancelAddress"
        /> -->
        <van-picker
          show-toolbar
          title="地址选择"
          :columns="jsonData.data"
          @confirm="confirmAddress"
          @cancel="cancelAddress"
          ref="picker"
          :default-index="10"
        />
      </van-popup>
      <van-cell-group>
        <van-field
          v-model="detailAddress"
          label="详细地址"
          placeholder="街道门牌信息"
        />
      </van-cell-group>
      <div
        class="history-ads"
        :class="{ have: haveHistory }"
        @click="goToHistory"
      >
        历史作业地址
      </div>
      <van-cell-group>
        <van-field
          v-model="cropNumber"
          label="作业亩数"
          placeholder="填写亩数"
          type="number"
        />
      </van-cell-group>
      <van-button
        native-type="submit"
        class="submit-btn"
        :class="{ active: getActive }"
      >
        提交
      </van-button>
    </van-form>
  </div>
</template>
<script>
import provinceList from "../../common/js/city.json";
// const provinceList = require("../../common/js/city.json");
import axios from "../../http";
import { mapMutations, mapState } from "vuex";
export default {
  name: "work_address",
  components: {},
  props: {},
  data() {
    return {
      newAddress: "", //省市区
      region_id: "", //区的id
      detailAddress: "", //详细地址
      cropNumber: "", //亩数
      haveHistory: false, //是否有历史作业地址
      showPicker: false,
      // areaList: provinceList, //省市的pick 数据
      jsonData: [],
      fromRoute: ""
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromRoute = from.name;
    });
  },
  computed: {
    getActive() {
      return this.newAddress && this.detailAddress && this.cropNumber;
    },
    ...mapState(["token", "addressList"])
  },
  watch: {
    fromRoute(newVal) {
      if (newVal == "history_address") {
        this.newAddress = this.$route.query.data.region;
        this.detailAddress = this.$route.query.data.address;
        this.region_id = this.$route.query.data.region_id;
      }
    }
  },
  mounted() {
    this.getHistoryAds();
    this.jsonData = provinceList;
    // console.log("provinceList :", city);
  },
  created() {
    // console.log("this.fromRoute :", this.fromRoute);
  },
  destroyed() {},
  methods: {
    ...mapMutations(["getAddressList", "getUserRegionId"]),
    getData(val) {
      console.log("getData :", val);
    },
    getHistoryAds() {
      //获取历史地址
      let that = this;
      axios
        .fetchPost("/member/work_address/gets", { token: this.token })
        .then(res => {
          if (res.data.code == 200 && res.data.data.length > 0) {
            this.haveHistory = true;
          } else {
            this.haveHistory = false;
          }
        });
    },
    confirmAddress(value, index) {
      //地址选择框pick
      this.newAddress = value[0] + value[1] + value[2]; //省市区地址描述
      let x = this.jsonData.data[index[0]].children[index[1]].children[index[2]]
        .id;
      console.log("x :", x);
      this.region_id = x;
      this.showPicker = false;
    },
    cancelAddress(val) {
      // console.log("val :", val);
      this.showPicker = false;
    },
    goToHistory() {
      //进入历史收获地址
      if (this.haveHistory) {
        this.$router.push({
          path: "/historyAddress"
        });
      } else {
        this.$toast("暂无历史作业地址");
      }
    },
    onSubmit(values) {
      //提交地址
      if (!this.getActive) {
        let msg =
          this.newAddress == ""
            ? "所在地不能为空"
            : this.detailAddress == ""
            ? "详细地址不能为空"
            : "作业亩数不能为空";
        this.$toast(msg);
        return;
      }
      if (this.$route.query.data) {
        let history_region = this.$route.query.data.region;
        let history_address = this.$route.query.data.address;
        let new_region = this.newAddress;
        let new_address = this.detailAddress;
        if (history_region == new_region && history_address == new_address) {
          let num = parseFloat(this.cropNumber).toFixed(2);
          let obj = {
            address: this.newAddress,
            detailAddress: this.detailAddress,
            cropNumber: num,
            id: this.$route.query.data.id
          };
          this.getAddressList(obj);
          if (this.addressList.length == 1) {
            this.getUserRegionId(this.$route.query.data.region_id);
          }
          this.$router.push({
            path: "/secondBar/medication"
          });
          return;
        }
      }
      axios
        .fetchPost("/member/work_address/add", {
          token: this.token,
          region_id: this.region_id,
          region: this.newAddress,
          address: this.detailAddress
        })
        .then(res => {
          let data = res.data;
          // let obj = { ...data.data, cropNumber: this.cropNumber };
          if (data.code == 200) {
            let num = parseFloat(this.cropNumber).toFixed(2);
            let obj = {
              address: this.newAddress,
              detailAddress: this.detailAddress,
              cropNumber: num,
              id: data.data.id
            };
            this.getAddressList(obj);
            if (this.addressList.length == 1) {
              this.getUserRegionId(data.data.region_id);
            }
            this.$router.push({
              path: "/secondBar/medication"
            });
          } else {
            this.$toast(data.msg);
          }
        })
        .catch(error => {
          console.log("error :", error);
        });
    }
  }
};
</script>
<style lang="stylus" scoped>
.adress-wrap
  text-align left
  .van-form
    padding-top 10px
  .history-ads
    line-height 45px
    font-size 14px
    font-family Microsoft YaHei
    font-weight 400
    color rgba(153, 153, 153, 1)
    text-indent 13px
    &.have
      color #55CC99
  .submit-btn
    display block
    width 66%
    background rgba(153, 153, 153, 0.7)
    border-radius 40px
    margin 45px auto
    font-size 17px
    font-family Microsoft YaHei
    font-weight 400
    color rgba(255, 255, 255, 1)
    text-align center
    height 40px
    line-height 40px
    &.active
      background #55CC99
</style>
